import React from "react";

import { ThemeProvider } from "@fluentui/react";
import { publicTheme } from "@configs/themeGenerator";
import { SignInForm } from "./signInForm";

export const SignInPage: React.FunctionComponent = () => {
  return (
    <ThemeProvider theme={publicTheme} applyTo="none">
      <SignInForm />
    </ThemeProvider>
  );
};
